var _line, _line2, _line3, _line4, _line5, _line6, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50.69,
    y1: 32,
    x2: 56.32,
    y2: 32
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.68,
    y1: 32,
    x2: 38.69,
    y2: 32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 26.54,
    y1: 15.97,
    x2: 56.32,
    y2: 15.97
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.68,
    y1: 15.97,
    x2: 14.56,
    y2: 15.97
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 48.03,
    x2: 56.32,
    y2: 48.03
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.68,
    y1: 48.03,
    x2: 23,
    y2: 48.03
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.55,
    cy: 15.66,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.69,
    cy: 32,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 48.03,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d829156b8953ced394d7319783df6318.svg";
export { ForwardRef as ReactComponent };